import React, { Component } from 'react'

// Types
import { FormProps, SearchState } from '../types'
import { Dispatch } from 'redux'

// Helpers
import { connect } from 'react-redux'
import i18n from 'i18n-js'

// Actions
import * as searchActions from '../actions';
import SearchForm from './SearchForm';
import SearchList from './SearchList';
import { API } from '../../api/api';

interface MyProps {

}

interface MyState {
  user: object;
  userLoading: boolean;
  isMoreOptionModal: boolean;
  formDataRes: object;
  dataList: any;
  dataListTotal: number;
  place: string;
  dateFrom: string;
  dateTo: string;
  solutions?: {uid?: number; description?: string},
  sizes?: {uid?: number; description?: string},
  ages?: {uid?: number; description?: string},
  time?: {uid?: number; description?: string, value: string},
  house: boolean;
  fencedGarden: boolean;
  noDogs: boolean;
  noBookings:boolean;
  limit: number;
  page: number;
  excludeIds: any;
  isLoading: boolean;
  resetPage: boolean;
  isFirstLoad: boolean;
}

interface Resp {
  result: [];
}

class Form extends Component<MyProps, MyState> {
  constructor(props: Readonly<MyProps>) {
    super(props);

    this.state = {
      user: null,
      userLoading: true,
      isMoreOptionModal: false,
      formDataRes: {},
      dataList: [],
      dataListTotal: 0,
      place: '',
      dateFrom: '',
      dateTo: '',
      solutions: null,
      sizes: null,
      ages: null,
      time: null,
      house: false,
      fencedGarden: false,
      noDogs: false,
      noBookings:false,
      limit: 10,
      page: 1,
      excludeIds: [],
      isLoading: false,
      resetPage: false,
      isFirstLoad: true
    }

    this.setStateValue = this.setStateValue.bind(this);
    this.searchAction = this.searchAction.bind(this);
    this.loadMore = this.loadMore.bind(this);
  }

  // _handleSubmit = (event: any) => {
  //   event.preventDefault()
  //   // const { query } = event.target
  // }

  async componentWillMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const place = urlParams.get('place');
    // if (place) {
    //   let inputSearch: any = document.getElementById("search-location");
    //   inputSearch.value = place;
    // }

    await this.setState({ place});
    try {
      const user = await API.getUser();
      await this.setState({ user: user && user.result, userLoading: false });
    } catch (e) {
      await this.setState({ userLoading: false });
      // console.log(e)
    }
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const place = urlParams.get('place');
    if (place) {
      let inputSearch: any = document.getElementById("search-location");
      inputSearch.value = place;
    }
    API.searchFormData()
      .then((response: Resp) => {
        this.setState({ formDataRes: response.result });
      });

    this.loadMore();
  }

  setStateValue(value: object) {
    this.setState(value);
  }

  async selectDate(date: string, str: string) {
    const { dateFrom, dateTo } = this.state;

    if (dateFrom && dateTo) {
      const from = new Date(dateFrom);
      const to = new Date(dateTo);
      let isCheckout = false;

      if (from <= to) {
        isCheckout = true;
      }
      // this.setState({ isCheckout: isCheckout });
    } else {

    }

    switch(str) {
      case 'from':
        await this.setState({ dateFrom: date });
        break;

      case 'to':
        await this.setState({ dateTo: date });
        break;
    }
  }

  async loadMore() {
    const { dataList } = this.state;
    const tempArr = [];

    if (dataList) {
      const count = dataList.length >= 10 ? 10 : dataList.length;

      for (let x=0; x < count; x++) {
        if (dataList[x] && dataList[x].uid) {
          tempArr.push(dataList[x].uid)
        }
      }

      await this.setState({ excludeIds: tempArr });
    }

    this.searchAction();
  }

  async searchAction(resetPage = false) {
    if(resetPage) {
      await this.setState({
        isMoreOptionModal: false,
        dataList: [],
        dataListTotal: 0,
        limit: 10,
        page: 1,
        resetPage: true
      })
    }

    const {
      dataList,
      place,
      dateFrom,
      dateTo,
      solutions,
      sizes,
      ages,
      time,
      house,
      fencedGarden,
      noDogs,
      noBookings,
      page,
      limit,
      excludeIds,
      isLoading,
      isFirstLoad,
    } = this.state;

    if (!isLoading) {
      await this.setState({ isLoading: true });
      let newPlace = place;
      if (!newPlace) {
        const doc: any = document.getElementById("search-location");
        newPlace = doc.value;
      } else {
        this.setState({ place: null });
      }

      const bParams = {
        place: newPlace,
        dateFrom,
        dateTo,
        solution: solutions && (solutions.description !== 'All') ? solutions.uid : null,
        sizes: sizes && (sizes.description !== 'All') ? sizes.uid : null,
        ages: ages && (ages.description !== 'All') ? ages.uid : null,
        time: time && (time.description !== 'All') ? time.uid : null,
        house,
        fencedGarden,
        noDogs,
        noBookings,
        page,
        limit,
        exclude: excludeIds,
      }

      API.search(bParams)
        .then((response: Resp) => {
          let result: any = response.result;
          if (response.result) {
            result = result.filter((n: any) => n);

            result = this.getUnique(result, 'uid');
          }

          if (isFirstLoad) {
            this.setState({ isFirstLoad: false });
            window.scrollTo(0, 0);
          }

          var element = document.querySelector('#box-search-list');
        	var position = element.getBoundingClientRect();

          if(response.result.length <= limit && position.top < window.innerHeight && position.bottom <= 0) {
            window.scrollTo(0, document.body.scrollHeight / 2);
          }

          this.setState({
            dataList: dataList.concat(result),
            dataListTotal: response.result.length,
            page: page + 1,
            isLoading: false,
            resetPage: false
          });
        })
        .catch((e) => {
          console.log(e)
          this.setState({ isLoading: false, resetPage: false });
        });
    }
  }

  getUnique(arr: any, comp: any)  {
    const unique = arr.map((e: any) => e[comp])
       // store the keys of the unique objects
      .map((e: any, i: any, final: any) => final.indexOf(e) === i && i)
      // eliminate the dead keys & store unique objects
      .filter((e: any) => arr[e]).map((e: any) => arr[e]);

    return unique;
  }

  render() {
    const {
      user,
      userLoading,
      place,
      isMoreOptionModal,
      dateFrom,
      dateTo,
      formDataRes,
      dataList,
      dataListTotal,
      solutions,
      sizes,
      ages,
      time,
      house,
      fencedGarden,
      noDogs,
      noBookings,
      page,
      limit,
      resetPage
    } = this.state;

    let toSearch = {
      place,
      solutions,
      sizes,
      ages,
      time,
      house,
      fencedGarden,
      noDogs,
      noBookings,
      page,
      limit
    }

    return (
      <div className="box-search-page">
        <SearchForm
          setStateValue={this.setStateValue}
          isMoreOptionModal={isMoreOptionModal}
          selectDate={this.selectDate.bind(this)}
          dateFrom={dateFrom}
          dateTo={dateTo}
          formDataRes={formDataRes}
          toSearch={toSearch}
          loadMore={this.loadMore}
          searchAction={this.searchAction}
          user={user}
          userLoading={userLoading}
          {...this.props}
        />
        <SearchList
          {...this.props}
          setStateValue={this.setStateValue}
          dataList={dataList}
          loadMore={this.loadMore}
          dataListTotal={dataListTotal}
          limit={limit}
          user={user}
          place={place}
          resetPage={resetPage}
        />
      </div>
    )
  }

}

const mapStateToProps = (state: SearchState) => ({
  search: state.query
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  handleSearch: (query: string) => dispatch(searchActions.searchQuery(query))
})

export default connect(mapStateToProps, mapDispatchToProps)(Form)
